import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableHighlight,
  TouchableOpacity,
} from 'react-native';
import { Large, Small } from '@dbk/ui-text';
import NavigationArrow from '../../../../components/common/navigation-arrow';
import styles from './row.styles';

const RecentSearchRow = (props) => (
  <TouchableOpacity
    onClick={() => props.selectedRow(props)}
    className="search-icon"
  >
    <View style={styles.container} id={`txt_serachTxt_recentSearch_test_${props.index}`}>
      <View style={styles.portfolioText}>
        <Large secondary>{`${props.pfId}`}</Large>
      </View>
      <View style={styles.text}>
        <Large secondary>{`${props.psDesc}`}</Large>
      </View>
      <View style={styles.rowRight}>
        <NavigationArrow style={styles.arrowRight} size="large" />
      </View>
    </View>
  </TouchableOpacity>
);

export default RecentSearchRow;
